import { useState, useEffect } from "react";

import { useUser } from "MVVM/Hooks/useUser";
import { cameFromGoogle } from "MVVM/Utilities/Referrer";
import { analytics } from "MVVM/Analytics";
import { NoticeBanner } from "../NoticeBanner";

const BANNER_HASH = "allstar-clips";
const DISMISS_KEY = `banner-announcement-${BANNER_HASH}-has-been-closed`;
const PROMO = { type: "noticeBanner", promotionName: "allstarClipsBanner" };

const AllstarClipsBanner = () => {
  const { allstarUser } = useUser();
  const [shouldShow, setShouldShow] = useState(
    !localStorage.getItem(DISMISS_KEY),
  );

  const visible = !allstarUser.loggedIn && shouldShow && cameFromGoogle();

  useEffect(() => {
    if (visible) analytics.track("Promotion - Impression", PROMO);
  }, [visible]);

  if (!visible) return <></>;

  const onDismiss = (show: boolean) => {
    if (!show) analytics.track("Promotion - Dismiss", PROMO);
    setShouldShow(show);
  };

  const onClick = () => analytics.track("Promotion - Button Click", PROMO);

  return (
    <NoticeBanner
      hash={BANNER_HASH}
      href="/!allstar"
      backgroundColor="#4dbd94"
      display="flex"
      setShouldShow={onDismiss}
      onClick={onClick}
    >
      Did you !allstar in-game? Search your SteamID to find your clips.
    </NoticeBanner>
  );
};

export { AllstarClipsBanner };
